export default "__VITE_ASSET__CxgvpM7W__"